import { render, staticRenderFns } from "./MyTabPane.vue?vue&type=template&id=77f8e766"
import script from "./MyTabPane.vue?vue&type=script&lang=js"
export * from "./MyTabPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports